import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";
import { red, lightGreen, amber, grey } from "@material-ui/core/colors";

let theme = createMuiTheme({
  props: {
    MuiButtonBase: {
      disableRipple: true,
      disableTouchRipple: true,
    },
  },
  palette: {
    type: "light",
    primary: {
      main: amber[400],
      dark: amber[600],
    },
    secondary: {
      main: lightGreen[800],
      dark: lightGreen[900],
    },
    error: {
      main: red.A400,
    },
    contrastThreshold: 3,
    tonalOffset: 0.3,
  },
  shape: {
    borderRadius: 4,
  },
  typography: {
    fontSize: 14,
    htmlFontSize: 10,
    fontFamily: ["Noto Sans", "Arial", "sans-serif"].join(","),
    button: {
      textTransform: "none",
      fontWeight: "bold",
    },
    h1: {
      fontSize: "2.488rem",
    },
    h2: {
      fontSize: "2.074rem",
    },
    h3: {
      fontSize: "1.728rem",
    },
    h4: {
      fontSize: "1.44rem",
    },
    h5: {
      fontSize: "1.2rem",
    },
    h6: {
      fontSize: "1rem",
    },
  },
  overrides: {
    MuiLink: {
      root: {
        color: grey[900],
        fontWeight: 700,
      },
    },
    MuiInputBase: {
      input: {
        fontSize: "16px",
      },
    },
    MuiInputLabel: {
      outlined: {
        "&$shrink": {
          position: "relative",
          transform: "translate(0, 0) scale(1)",
          marginBottom: 4,
        },
      },
    },
    MuiGrid: {
      item: {
        maxWidth: "100%",
      },
    },
    MuiSelect: {
      outlined: {
        padding: "9px 4px",
      },
    },
    MuiCardActions: {
      root: {
        padding: "16px",
      },
    },
    MuiCardHeader: {
      title: {
        fontWeight: 700,
        marginBottom: 0,
      },
    },
    MuiListItemText: {
      inset: {
        paddingLeft: "16px",
      },
    },
  },
});

theme = responsiveFontSizes(theme, {
  breakpoints: ["sm"],
  disableAlign: false,
  factor: 1.5,
});

export default theme;
